<template>
    <v-container class="login-page" fluid>
        <v-row justify="center" class="footer-section">
            <v-col cols="12" sm="4" class="footer-column text-center">
                <v-card class="pa-8 login-card rounded-xl" elevation="20" style="max-width: 500px; margin: auto; background: linear-gradient(145deg, #f8f9fa, #e9ecef);">

  <v-card-title class="text-h4 text-center font-weight-bold" style="color: #4A4A4A;">👋 Welcome Back</v-card-title>
  <v-card-subtitle class="text-center mb-5" style="color: #6c757d;">Sign in to access your account</v-card-subtitle>

  <!-- Form -->
  <v-form v-model="valid" lazy-validation>
    <!-- Email Input -->
     <!-- Email Input -->
  <v-text-field
    v-model="email"
    label="Email Address"
    type="email"
    :rules="[rules.required, rules.email]"
    variant="outlined"
    dense
    class="mb-4"
    style="background-color: white; border-radius: 8px;"
    prepend-inner-icon="mdi-email"
  ></v-text-field>

    <!-- Password Input -->
     <!-- Password Input -->
  <v-text-field
    v-model="password"
    :type="showPassword ? 'text' : 'password'"
    label="Password"
    :rules="[rules.required]"
    variant="outlined"
    dense
    class="mb-4"
    style="background-color: white; border-radius: 8px;"
    prepend-inner-icon="mdi-lock"
    append-inner-icon="mdi-eye"
    @click:append-inner="togglePassword"
  ></v-text-field>

    <!-- Sign In Button -->
    <v-btn
      color="primary"
      block
      class="mt-4 py-3 text-capitalize font-weight-bold"
      :disabled="!valid"
      :loading="loading"
      style="background: linear-gradient(135deg, #42a5f5, #1e88e5); box-shadow: 0 5px 10px rgba(30, 136, 229, 0.4); border-radius: 8px;"
      @click="submit"
    >
      Sign In
    </v-btn>

    <!-- Forgot Password -->


  </v-form>

  <!-- Divider -->
  <v-divider class="my-4"></v-divider>

  <!-- Sign Up Section -->
 
</v-card>

        </v-col>
      </v-row>
    </v-container>

      <!-- Snackbar for messages -->
      <v-snackbar v-model="snackbar.visible" :timeout="3000">
      {{ snackbar.message }}
      <v-btn color="red" text @click="snackbar.visible = false">Close</v-btn>
    </v-snackbar>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
    data() {
      return {
        email: '',
        password: '',
        valid: false,
        showPassword: false, // Toggles the password view
        loading: false, // Initialize loading state
        snackbar: {
        visible: false,
        message: '',
      },

        rules: {
          required: value => !!value || 'This field is required',
          email: value => /.+@.+\..+/.test(value) || 'Enter a valid email',
        },
      };
    },
    methods: {

        togglePassword() {
      this.showPassword = !this.showPassword; // Toggle the visibility state
    },
    async submit() {
      this.loading = true; // Set loading to true when starting the request
      try {
        const response = await this.$store.dispatch('alumnilogin', { email: this.email, password: this.password });

        if (response.status===200) {
          // this.$store.commit('setUser ', response.data.user);
          this.$router.push('/alumni');
        } else {
          console.log(response.data.message);
          this.showSnackbar(response.data.message,"error");
        }
      } catch (error) {
        this.showSnackbar('Error logging in. Please try again.');
      } finally {
        this.loading = false; // Set loading to false when the request is complete
      }
    },
    showSnackbar(message) {
      this.snackbar.message = message;
      this.snackbar.visible = true; // Show the Snackbar
    },
      forgotPassword() {
        alert('Redirect to forgot password page!');
      },
      signUp() {
        alert('Redirect to sign-up page!');
      },
    },
  };
  </script>

  
  
  <style scoped>
  /* General Footer Styles */
  .custom-footer {
  background: linear-gradient(45deg, rgb(255, 6, 18) 0%, #390100 100%);
  color: #15f6eb;
  padding: 100px 0;
  border-top: 15px solid #03a9f4;
  position: relative;
  overflow: hidden;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.5);
  border-radius: 30px 30px 0 0;
  z-index: 2;
  font-family: 'Roboto', sans-serif;
  }
  
  .footer-section {
  margin-bottom: 10px;
  z-index: 3;
  }
  
  .footer-column {
  margin-top: 100px;
  padding: 40px;
  background-color:#eaf1f6;
  transition: transform 0.5s ease, box-shadow 0.5s ease, filter 0.5s ease;
  cursor: pointer;
  z-index: 3;
  }
  .footer-columnm {
  padding: 40px;
  transition: transform 0.5s ease, box-shadow 0.5s ease, filter 0.5s ease;
  cursor: pointer;
  z-index: 3;
  }
  .footer-columnm:hover {
  transform: translateY(-12px); /* Smooth elevation on hover */
  box-shadow: 0 35px 80px rgb(8, 82, 131); /* More prominent shadow effect */
  filter: brightness(1.2); /* Slight brightness increase */
  border-top-left-radius: 100px;
  border-bottom-right-radius: 100px;
  }
  .footer-column:hover {
  transform: translateY(-12px); /* Smooth elevation on hover */
  box-shadow: 0 35px 80px rgb(8, 82, 131); /* More prominent shadow effect */
  filter: brightness(1.2); /* Slight brightness increase */
  border-top-left-radius: 100px;
  border-bottom-right-radius: 100px;
  }
  
  .footer-heading {
  font-family: 'Roboto', sans-serif;
  font-size: 2rem;
  font-weight: 700;
  color: #ff0808;
  margin-bottom: 20px;
  text-transform: uppercase;
  text-shadow: 0 0 8px rgb(0, 110, 255);
  transition: color 0.3s ease, letter-spacing 0.3s ease;
  }
  .footer-headingg {
  font-family: 'Roboto', sans-serif;
  font-size: 3rem;
  font-weight: 700;
  color: #ff0606;
  margin-bottom: 20px;
  text-transform: uppercase;
  text-shadow: 0 0 8px rgb(0, 115, 255);
  transition: color 0.3s ease, letter-spacing 0.3s ease;
  }
  .footer-heading:hover {
  color: #e00b0b;
  letter-spacing: 3px;
  text-shadow: 0 0 20px rgba(8, 64, 90, 0.9);
  }
  .footer-headingg:hover {
  color: #ffffff;
  letter-spacing: 3px;
  text-shadow: 0 0 20px rgba(8, 64, 90, 0.9);
  }
  .footer-text {
  font-size: 1.4rem;
  color: #9d0606;
  margin-bottom: 18px;
  line-height: 1.8;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: opacity 0.3s ease;
  }
  
  .footer-text:hover {
  opacity: 0.85;
  }
  
  .footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
  }
  
  .footer-links li {
  margin-bottom: 18px;
  }
  
  .footer-links a {
  color: #d40b0b;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease, transform 0.3s ease;
  font-size: 1.3rem;
  }
  
  .footer-links a:hover {
  color: #f40303;
  transform: scale(1.1);
  }
  
  .social-icons {
  margin-top: 60px;
  display: flex;
  justify-content: center;
  }
  
  .social-icon {
  color: #118ecd;
  margin: 0 18px;
  transition: transform 0.4s ease, color 0.4s ease, box-shadow 0.4s ease;
  font-size: 3rem;
  cursor: pointer;
  }
  
  .social-icon:hover {
  transform: scale(1.4);
  color: #03a9f4;
  box-shadow: 0 0 25px rgba(0, 169, 244, 0.5);
  }
  
  .footer-bottom {
  font-size: 1.5rem;
  color: #ddd;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 400;
  opacity: 0.9;
  transition: opacity 0.3s ease, letter-spacing 0.3s ease;
  }
  
  .footer-bottom:hover {
  opacity: 1;
  letter-spacing: 5px;
  }
  
  /* Curved Background Styling */
  .footer-curve {
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  height: 200px;
  background: #7b0303;
  z-index: 1;
  border-radius: 50% 50% 0 0;
  box-shadow: 0 25px 50px rgba(4, 58, 120, 0.825);
  transform: scaleY(-1);
  animation: curveAnimation 9s ease-in-out infinite;
  }
  
  /* Animated Background */
  @keyframes curveAnimation {
  0% {
    transform: scaleY(1);
  }
  50% {
    transform: scaleY(0.5);
  }
  100% {
    transform: scaleY(1);
  }
  }
  
  /* Responsive Adjustments */
  @media (max-width: 600px) {
  .footer-heading {
    font-size: 2.5rem;
  }
  
  .footer-text {
    font-size: 1.1rem;
  }
  
  .footer-curve {
    height: 250px;
    top: -180px;
  }
  
  .social-icon {
    font-size: 2.5rem;
  }
  }
  
  /* Circular counter styling */
  .circular-counter {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  }
  
  .counter-wrapper {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff0000, #5d0404);
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
  animation: popIn 0.6s ease-out;
  }
  
  .animated-number {
  font-size: 2.5rem;
  font-weight: bold;
  color: white;
  text-align: center;
  animation: scaleBounce 1.2s infinite ease-in-out;
  }
  
  /* Scale bounce animation for the number */
  @keyframes scaleBounce {
  0%,
  100% {
  transform: scale(1);
  }
  50% {
  transform: scale(1.2);
  }
  }
  
  /* Pop-in effect for the circular counter */
  @keyframes popIn {
  0% {
  transform: scale(0);
  opacity: 0;
  }
  100% {
  transform: scale(1);
  opacity: 1;
  }
  }
  
  /* Add a subtle bounce to the entire circle */
  .animated-bounce {
  animation: bounceEffect 1.5s infinite;
  }
  
  @keyframes bounceEffect {
  0%, 100% {
  transform: translateY(0);
  }
  50% {
  transform: translateY(-10px);
  }
  }
  </style>
  